/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectDailyExpectedTasksQuery } from '../../models/get-project-daily-expected-tasks-query';
import { GetProjectDailyExpectedTasksQueryResult } from '../../models/get-project-daily-expected-tasks-query-result';

export interface ApiProjectDailyExpectedTasksGetProjectDailyExpectedTasksPost$Plain$Params {
      body?: GetProjectDailyExpectedTasksQuery
}

export function apiProjectDailyExpectedTasksGetProjectDailyExpectedTasksPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectDailyExpectedTasksGetProjectDailyExpectedTasksPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectDailyExpectedTasksQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectDailyExpectedTasksGetProjectDailyExpectedTasksPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectDailyExpectedTasksQueryResult>;
    })
  );
}

apiProjectDailyExpectedTasksGetProjectDailyExpectedTasksPost$Plain.PATH = '/api/ProjectDailyExpectedTasks/GetProjectDailyExpectedTasks';
